// @flow
import React, { Component } from 'react';
import {
  ReferralsHeaderDiv,
  HeaderTotalH6,
  ViewAllLink
} from './ReferralsStyles';
import NavTabs from '../../../components/NavTabs';
import HeaderTab from '../../../components/HeaderTab';
import { MERCHANTS, PARTNERS } from './reducer';
import { SpacerTab } from '../../../components/TabStyles';
import { MobileHiddenSpan } from '../../../components/ResponsiveHelpersStyles';

type Props = {
  activeSection: string,
  setActiveSection: (section: string) => void,
  total_users: number,
  flippers: {
    partner_referrals: boolean
  }
};

export default class Header extends Component<Props> {
  componentDidUpdate(prevProps: Props) {
    // trigger moving active tab hr
    if (this.props.activeSection !== prevProps.activeSection) {
      window.dispatchEvent(new Event('resize'));
    }
  }

  render() {
    const viewAllLink =
      this.props.activeSection === 'MERCHANTS'
        ? '/merchants'
        : '/partners/referred';
    return (
      <ReferralsHeaderDiv>
        <NavTabs>
          <HeaderTab
            activeSection={this.props.activeSection}
            setActiveSection={this.props.setActiveSection}
            sectionName="Recent Merchant Signups"
            mobileSectionName="Merchants"
            sectionValue={MERCHANTS}
            noFlex
          />
          {this.props.flippers.partner_referrals && (
            <HeaderTab
              activeSection={this.props.activeSection}
              setActiveSection={this.props.setActiveSection}
              sectionName="Recent Partner Signups"
              mobileSectionName="Partners"
              sectionValue={PARTNERS}
              noFlex
            />
          )}

          <SpacerTab mobile tablet />
          {this.props.total_users > 0 ? (
            <ViewAllLink to={viewAllLink}> View All </ViewAllLink>
          ) : (
            <HeaderTotalH6>
              Total
              <MobileHiddenSpan> {this.props.activeSection}</MobileHiddenSpan>:
              0
            </HeaderTotalH6>
          )}
        </NavTabs>
      </ReferralsHeaderDiv>
    );
  }
}
